import proj4 from 'proj4';
import { PolygonClippedGridSystem, extentFromPolygon, } from '@zwaarcontrast/ol-graticule';
import { ProjectedGridSystem, registerCRS, } from '@zwaarcontrast/ol-graticule-projected';
import { NGO_STRIPS } from './strips.js';
const EXTENT_MARGIN_M = 100_000;
/** Grid system for one strip, clipped to where German sheets print it. */
export function createNGOStripGridSystem(strip, options) {
    const { crs, proj4: def, printedValidityWgs84: validity } = NGO_STRIPS[strip];
    registerCRS(crs, def);
    const toGrid = proj4('EPSG:4326', def);
    const projected = validity.map(([lon, lat]) => {
        const [x, y] = toGrid.forward([lon, lat]);
        return [x ?? 0, y ?? 0];
    });
    return new PolygonClippedGridSystem({
        source: new ProjectedGridSystem({
            ...options,
            crs,
            extent: extentFromPolygon(projected, EXTENT_MARGIN_M),
        }),
        clipPolygon: { rings: [validity], crs: 'EPSG:4326' },
    });
}
function toGrid(def) {
    return {
        crs: def.crs,
        name: `Norwegian strip ${def.strip}`,
        proj4: def.proj4,
        createGridSystem: () => createNGOStripGridSystem(def.strip),
        validityWgs84: [def.printedValidityWgs84],
    };
}
/** Every strip, keyed by CRS. */
export const NGO_GRIDS = Object.fromEntries(Object.values(NGO_STRIPS).map((def) => [def.crs, toGrid(def)]));
//# sourceMappingURL=grids.js.map